<form [formGroup]="form">
    <mat-form-field class="full-width">
        <mat-label>Institución derivante</mat-label>
        <input type="text" #referringPhysicianInstituteCtrl formControlName="ReferringPhysicianInsituteCtrl" matInput placeholder="Busque por nombre"  (input)="textChanged($event.target.value)" (input)="onReferringPhysicianInstituteFilterChange()" [matAutocomplete]="autReferringPhysician">
        <mat-autocomplete #autReferringPhysician="matAutocomplete" (optionSelected)="referringPhysicianFilterSelected($event.option.value)" [displayWith]="displayFn">
            <mat-option *ngFor="let referringPhysicianInstituteFilter of referringPhysiciansInstituteFilter" [value]="referringPhysicianInstituteFilter">
                <div>
                    <b>{{ referringPhysicianInstituteFilter.Name }}</b>
                </div>
            </mat-option>
        </mat-autocomplete>
        <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
    </mat-form-field>
    <button matSuffix type="button" *ngIf="!loading && !isSelected && !readOnly" (click)="create()" mat-mini-fab>
      <mat-icon>add</mat-icon>
</button>
  <button matSuffix type="button" *ngIf="!loading && isSelected && !readOnly" (click)="edit()" mat-mini-fab>
    <mat-icon>edit</mat-icon>
</button>
</form>
